import React from 'react';
import './authUserInfo.scss';
import { User } from 'phosphor-react';
import { useSelector } from 'react-redux';
import { selectUserName } from '../../../store/slice/headerInfoSlice';

const AuthUserInfo = () => {
  const userName = useSelector(selectUserName);
  return (
    <div className={'user'}>
      <div className={'user__avatar online'}>
        <User size={24} />
      </div>
      <div className={'user__name'}>{userName}</div>
    </div>
  );
};

export default AuthUserInfo;
